import "./App.css";
import Toaster from "./components/reusable-toaster/Toaster";
import AppRoutes from "./routes/AppRoutes";
import { BrowserRouter as Router } from "react-router-dom";

function App() {
  return (
    <div className="App">
      <Toaster />
      <Router>
        <AppRoutes />
      </Router>
    </div>
  );
}

export default App;
